import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CacheService } from "@delon/cache";
import { NzModalRef } from "ng-zorro-antd/modal";

interface Option {
  label: string;
  value: any;
}

@Component({
  selector: "host-house-type-picker-v3_4",
  templateUrl: "./house-type-picker-v3_4.component.html",
  styleUrls: ["./house-type-picker-v3_4.component.scss"],
})
export class HouseTypePickerComponent_v3_4 implements OnInit {
  listOfTagOption = [];
  tagId = null;
  listOfType = [];
  @Input() selectedTypes = new Set();
  @Input() filteredTypes = [];
  @Input() mode: "single" | "multiple" = "multiple";
  /// 是否发射值
  /// 作为普通组件，该值需设置true；作为modal组件，该值为false，modal组件有其独有的传值方式
  @Input() emitValue = false;
  @Output() onChange = new EventEmitter<Option[]>();

  constructor(
    private cacheSrv: CacheService,
    private http: HttpClient,
    private modalRef: NzModalRef,
  ) {}

  ngOnInit() {
    this.fetchTagList();
    this.fetchTypeList();
  }

  private fetchTagList() {
    return this.cacheSrv
      .get("/api/house_status_setting/get", { mode: "promise", type: "m", expire: 1 * 60 })
      .subscribe((rst: any) => {
        const list = rst?.data?.house_tag ?? [];
        this.listOfTagOption = list.map((item) => ({
          label: item.name,
          value: item.id,
        }));
      });
  }

  private fetchTypeList() {
    const params = {
      house_tag_id: this.tagId,
    };
    return this.http.get("/api/house_type/all", { params }).subscribe((rst: any) => {
      const list = rst?.data?.list ?? [];
      this.listOfType = list
        .filter((type) => !this.filteredTypes.includes(type.id))
        .map((type) => ({ label: type.title, value: type.id }));
      if (this.tagId && this.mode === "multiple") {
        this.onSelectAll();
      }
    });
  }

  onFilter(value) {
    this.tagId = value;
    this.selectedTypes.clear();
    this.fetchTypeList();
  }

  onSelect(typeId) {
    if (this.selectedTypes.has(typeId)) {
      this.selectedTypes.delete(typeId);
    } else {
      if (this.mode === "single") {
        this.selectedTypes.clear();
      }

      this.selectedTypes.add(typeId);
    }
  }

  onSelectAll() {
    const typeIds = this.listOfType.map((h) => h.value);
    this.selectedTypes = new Set(typeIds);
  }

  onConfirm() {
    const ids = Array.from(this.selectedTypes);
    const selectedTypes = this.listOfType.filter((h) => ids.includes(h.value));
    if (this.emitValue) {
      this.onChange.emit(selectedTypes);
    } else {
      this.modalRef.destroy({
        type: "ok",
        data: selectedTypes,
      });
    }
  }

  onCancel() {
    this.modalRef.destroy();
  }
}
